export default {
    namespaced:true,
    state: {
        OperatorId:localStorage.getItem('CJG_OperatorId')?localStorage.getItem('CJG_OperatorId'):sessionStorage.getItem('CJG_OperatorId'),
        title:"藏经阁",
        path:"/gateway",
        tabbar:"module",
        Id:'',//业务Id
    },
    //用于操作数据的同步方法
    mutations: {
        changeTitle(state: any, data: any) {
            state.title = data
        },
        changeClass(state: any, data: any){
            state.path = data
        },
        changeOperatorId (state:any,value:any){
            state.OperatorId = value
        },
        changeTabbar(state:any,value:any){
            state.tabbar = value
        },
        changeId(state: any, data: any) {
            state.Id = data
        },
    },
}